<!-- <div class="slider-container" #sliderContainer [style.height]="height" [class.rtl]="isRTL">
  <div class="slide" #slideEl>
    <div class="item" 
         *ngFor="let item of orderedItems; trackBy: trackById"
         [style.background-image]="'url(' + (item.attachment || 'assets/images/placeholder.png') + ')'"
         (click)="onItemClick(item)">
      <div class="content">
        <div class="name">{{ isRTL && item.title ? item.title : item.title }}</div>
        <div class="description" *ngIf="item.description || item.description">
          {{ isRTL && item.description ? item.description : item.description }}
        </div>
      </div>
    </div>
  </div>

  <div class="button" *ngIf="items.length > 1">
    <button class="prev" (click)="prev()">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>
    <button class="next" (click)="next()">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>
  </div>
</div> -->
<div #sliderContainer 
     class="slider-container" 
     [class.rtl]="isRTL"
     [style.--drag-offset.px]="dragOffset"
     [style.--drag-progress]="dragProgress"
     [style.--drag-progress-abs]="dragProgressAbs"
     [ngClass]="inTransit ? (isNext ? slideChangeAnimationNextClass : slideChangeAnimationPrevClass) : ''">
  
  <div class="slide">
    <div *ngFor="let item of orderedItems; let i = index; trackBy: trackById"
         class="item"
         [style.background-image]="'url(' + (item.attachment || 'assets/images/placeholder.png') + ')'"
         [ngClass]="{
           'item-active': i === activeIndex,
           'item-prev': i === (activeIndex - 1 + orderedItems.length) % orderedItems.length,
           'item-next': i === (activeIndex + 1) % orderedItems.length
         }"
         (click)="onItemClick(item)">
      
      <div class="content" *ngIf="i === activeIndex">
         <div class="name">{{ item.title }}</div>
      </div>
    </div>
  </div>
    <div class="button" *ngIf="items.length > 1">
    <button class="prev" (click)="prev()">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>
    <button class="next" (click)="next()">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>
  </div>
</div>